import request from '@/helpers/request'

export default {
  async list() {
    return await request.get('notification')
  },
  async show(id) {
    return await request.get(`notification/${id}`)
  },
  async paginate(page) {
    return await request.get('notification?page=' + page)
  },
  async read(notiId) {
    return await request.get('read_notification/' + notiId)
  },
  async updatePayment() {
    return await request.get('update_notification/')
  }
}
